import React, { useEffect } from 'react';
import { formatAddress, getTimestamp } from '../utils';
import { useSelector, useDispatch } from 'react-redux';
import { fetchSample } from '../redux/actions';
import _ from 'lodash';
import '../preview.css';

export const Main = () => {
  const state = useSelector((state) => state);
  const dispatch = useDispatch();

  const { insights = [] } = state.data || {};

  useEffect(() => {
    if (state.data.length === 0) {
      dispatch(fetchSample());
    }

    if (state.data.length !== 0) {
      const timer = setTimeout(() => {
        dispatch(fetchSample());
      }, 10000);

      return () => clearTimeout(timer); // ✅ fixed
    }
  }, [state.fetchCounter]);

  // ✅ log timestamps being rendered
  useEffect(() => {
    console.log('=== Rendering insights ===');
    insights.forEach((item) => {
      const age = ((Date.now() - item.timestamp) / 60000).toFixed(1);
      console.log(`${item.name}: ${age} minutes ago`);
    });
  }, [insights]);

  const parseStatus = (tokenStatus) => {
    let status = tokenStatus.signal;
    if (status === 'curve') status = 'curve updated';
    if (status === 'volume') status = 'volume detected';
    if (status === 'verified') status = 'contract verified';
    if (status === 'burned') status = 'liquidity burned';
    if (status === 'dextools_updated') status = 'dextools updated';
    if (status === 'snipers') status = 'snipers detected';
    if (status === 'initials') status = 'liquidity added';
    if (status === 'launched') status = 'contract deployed';
    if (status === 'trending_buybot') status = 'entered trending via buybot';
    if (status === 'trending_deluge') status = 'entered trending via deluge';
    if (status === 'rugged') status = '[ 💩 liquidity pulled'.padEnd(22, '\xa0') + ' ]';
    return status;
  };

  const parseName = (tokenName) => {
    let name = tokenName.split('(')[1].split(')')[0];
    return `${name}`.padEnd(30, '\xa0');
  };

  return (
    <div id="main">
      {_.isNil(insights) ? (
        <img src="./sachi2.png" />
      ) : (
        <>
          <img src="./sachi2.png" className="logo" />
          <ul className="hero">
            <li>
              <p>
<span className="senshi">
  シャチ Shachihoko meta, data, alpha v1 – [
  uniswap <img src="./green-dot.gif" style={{ position: 'relative', maxWidth: '25px', top: '7px', paddingRight: '5px' }} />
  raydium <img src="./green-dot.gif" style={{ position: 'relative', maxWidth: '25px', top: '7px', paddingRight: '5px' }} />
  pumpswap <img src="./green-dot.gif" style={{ position: 'relative', maxWidth: '25px', top: '7px', paddingRight: '5px' }} />
  ]
</span>
              </p>
            </li>
            <li className="social">
              <a href="https://t.me/shachi_portal" target="_blank">TG</a>
              <a href="https://x.com/shachi_eth" target="_blank">X</a>
              <a href="#" target="_blank">$SHACHI LOGIN</a>
              <a href="#" target="_blank">CA: 0xE3D362faA0dc46a287DB6d19922B6fc3e3c958fb</a>
            </li>
          </ul>
          <div id="senshi-container">
            <table id="senshi-preview">
              {insights
                .sort((a, b) => b.timestamp - a.timestamp)
                .map((insight) => (
                  <tr key={insight.address + insight.timestamp}>
                    <td>
                      <span className="preview">
                        {insight.platform === 'solana'
                          ? 'raydium'
                          : insight.platform === 'pumpfun'
                          ? 'pumpfun'
                          : 'uniswap'}
                        @
                      </span>
                      <span className="senshi" style={{ paddingRight: '15px' }}>
                        preview.shachi:{' '}
                      </span>
                    </td>
                    <td className={insight.signal === 'tweet' ? 'tweet' : insight.signal === 'post' ? 'tg' : 'token'}>
                      {insight.name || ''}
                    </td>
                    <td className="status" style={{ paddingRight: '15px' }}>
                      {parseStatus(insight)}
                    </td>
                    <td style={{ paddingRight: '20px' }}>
                      {insight.signal === 'tweet' || insight.signal === 'post'
                        ? '–'.repeat(11)
                        : formatAddress(insight.address)}
                    </td>
                    <td className="timestamp">{getTimestamp(insight.timestamp).padEnd(17, '\xa0')}</td>
                  </tr>
                ))}
            </table>
          </div>
        </>
      )}
    </div>
  );
};
